"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _reactEasyCrop = _interopRequireDefault(require("react-easy-crop"));
var _Form = _interopRequireDefault(require("../../hocs/Form"));
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _getCroppedImg = require("../../../utils/getCroppedImg");
var _ts = require("../../ts");
var _Spacer = _interopRequireDefault(require("../../layout/Spacer"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  name: '',
  styles: '',
  handleOnCancel() {},
  handleSubmit() {},
  loading: false
};
function ImageCropper(props) {
  const {
    name,
    shape,
    styles,
    handleSubmit,
    handleOnCancel,
    loading,
    size,
    nextButtonText,
    cancelButtonText
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [crop, setCrop] = (0, _react.useState)({
    x: 0,
    y: 0
  });
  const [zoom, setZoom] = (0, _react.useState)(1);
  const [minZoom, setMinZoom] = (0, _react.useState)(1);
  const {
    setValue,
    watch
  } = _Form.default.useForm();
  const uploadedImageSrc = (0, _react.useMemo)(() => {
    var _watch, _watch2;
    return (_watch = watch(name)) !== null && _watch !== void 0 && _watch[0] ? URL.createObjectURL((_watch2 = watch(name)) === null || _watch2 === void 0 ? void 0 : _watch2[0]) : '';
  }, [watch(name)]);
  const cssContainerStyles = (0, _react.useMemo)(() => containerStyles(styles), [styles]);
  const handleMediaLoaded = _ref => {
    let {
      width,
      height
    } = _ref;
    const aspectRatio = width / height;
    let newMinZoom;
    if (aspectRatio >= 1) {
      // Image is landscape. Ensure height fills the crop area
      newMinZoom = size.height / height;
    } else {
      // Image is portrait. Ensure width fills the crop area
      newMinZoom = size.width / width;
    }
    setZoom(newMinZoom);
    setMinZoom(newMinZoom);
  };
  const handleZoomChange = newZoom => {
    setZoom(Math.max(newZoom, minZoom));
  };
  const onCropComplete = async (_, croppedAreaPixels) => {
    try {
      var _watch3;
      if (!croppedAreaPixels) return;
      const {
        type: fileType,
        name: fileName
      } = ((_watch3 = watch(name)) === null || _watch3 === void 0 ? void 0 : _watch3[0]) || {};
      const aspectRatio = 1;
      const croppedImageBlob = await (0, _getCroppedImg.getCroppedImg)(uploadedImageSrc, croppedAreaPixels, aspectRatio, fileType);
      const croppedImageFile = (0, _getCroppedImg.blobToFile)(croppedImageBlob, fileName);
      setValue('croppedImage', croppedImageFile);
    } catch (error) {
      console.error('Error cropping the image', error);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 25,
    styles: cssContainerStyles
  }, /*#__PURE__*/_react.default.createElement(CropperContainer, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_reactEasyCrop.default, {
    image: uploadedImageSrc,
    crop: crop,
    zoom: zoom,
    aspect: size.width / size.height,
    onCropChange: setCrop,
    onCropComplete: onCropComplete,
    onZoomChange: handleZoomChange,
    cropSize: size,
    onMediaLoaded: handleMediaLoaded,
    showGrid: false,
    cropShape: shape,
    style: {
      cropAreaStyle: {
        border: 'none'
      }
    }
  })), /*#__PURE__*/_react.default.createElement(InputRangeStyles, {
    type: "range",
    value: zoom,
    min: minZoom,
    max: 3,
    step: 0.1,
    "aria-labelledby": "Zoom",
    onChange: e => {
      setZoom(Number(e.target.value || minZoom));
    }
  }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    spaceType: "margin",
    topSpace: 50
  }, /*#__PURE__*/_react.default.createElement(_Column.default, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "white",
    outlined: true,
    width: "".concat(size.width, "px"),
    size: _ts.UIElementSizesEnum.Medium,
    onClick: handleSubmit,
    loading: loading,
    children: nextButtonText
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "white",
    outlined: true,
    width: "".concat(size.width, "px"),
    size: _ts.UIElementSizesEnum.Medium,
    onClick: handleOnCancel,
    children: cancelButtonText,
    disabled: loading,
    styles: cssCancelButtonStyles
  }))));
}
const containerStyles = inputStyles => (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: rbga(0, 0, 0, .15);\n  ", "\n"])), inputStyles);
const CropperContainer = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-top: 200px;\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n\n  ", "\n"])), _ref2 => {
  var _theme$colors;
  let {
    size,
    theme
  } = _ref2;
  return "\n    width: ".concat(size.width, "px;\n    height: ").concat(size.height, "px;\n    background-color: ").concat(theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 || (_theme$colors = _theme$colors.FONT) === null || _theme$colors === void 0 ? void 0 : _theme$colors.TITLE, ";\n  ");
});
const InputRangeStyles = _styled.default.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-slider-runnable-track {\n    background-color: #8a8a8a;\n    border-radius: 0px;\n    height: 1px;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    margin-top: -7px; /* Centers thumb on the track */\n    background-color: #e0e0e0;\n    border-radius: 15px;\n    height: 15px;\n    width: 15px;\n  }\n\n  &:focus::-webkit-slider-thumb {\n    outline: 3px solid #e0e0e0;\n    outline-offset: 0.125rem;\n  }\n\n  &::-moz-range-track {\n    background-color: #8a8a8a;\n    border-radius: 0px;\n    height: 1px;\n  }\n\n  &::-moz-range-thumb {\n    background-color: #e0e0e0;\n    border: none; /*Removes extra border that FF applies*/\n    border-radius: 15px;\n    height: 15px;\n    width: 15px;\n  }\n\n  &:focus::-moz-range-thumb{\n    outline: 3px solid #e0e0e0;\n    outline-offset: 0.125rem;\n  }\n"])));
const cssCancelButtonStyles = (0, _react2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n"])));
var _default = exports.default = ImageCropper;